export const SORT_DIRECTIONS = {
  ASC: "asc",
  DESC: "desc",
} as const;

export const TIMELINE_ITEM_COLORS = {
  MEDIUM_GRAY: "#BBBBBB",
  PURPLE: "rgba(102, 0, 192, 0.4)",
  RED: "#FF0000",
};

export const ZONE_BASED_PREDICTIONS_GROUP = "Zone Based Predictions" as const;

export const MIN_TIMELINE_RANGE = {
  beforeMinutes: 30,
  afterMinutes: 30,
};

export const MAX_TIMELINE_RANGE = {
  beforeMinutes: 120,
  afterMinutes: 120,
};
